import { useEffect, useState } from 'react'
import { reverseGeocode } from '../lib/geocode'

export interface CurrentPosition {
  lat: number
  lng: number
  label: string | null
}

export function useCurrentPosition(): CurrentPosition | null {
  const [position, setPosition] = useState<CurrentPosition | null>(null)

  useEffect(() => {
    if (!navigator.geolocation) return
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude: lat, longitude: lng } = pos.coords
        const label = await reverseGeocode(lat, lng)
        setPosition({ lat, lng, label })
      },
      () => {}, // permission denied or unavailable — silent fallback
      { timeout: 8000, maximumAge: 300_000 },
    )
  }, [])

  return position
}
